import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {etatsEditonListNames} from '../../../domain/common/etat-edition';

@Component({
    selector: 'app-table-etat-edition',
    templateUrl: './table-etat-edition.component.html',
    styleUrls: ['./table-etat-edition.component.css']
})
export class TableEtatEditionComponent implements OnInit {

    etatDetails: any;

    constructor(
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit(): void {
        this.activatedRoute.data.subscribe(data => {
            this.etatDetails = etatsEditonListNames[data.type];
        });
    }
}
